import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  LayoutUtilsService,
  MessageType,
  QueryParamsModel,
} from '../../../../../../core/_base/crud';
import { StringUtilsService } from '../../../../../../core/services/string-utils.service';
import { AppState } from '../../../../../../core/reducers';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CategoryDescription } from '../../../../../../core/lists/_models/category-description.model';
import { CategoryDescriptionService } from '../../../../../../core/lists/_services/category-description.service';
import { RelationshipCategoryService } from '../../../../../../core/lists/_services/relationship-category.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-reason-edit',
  templateUrl: './category-description-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryDescriptionEditComponent implements OnInit, OnDestroy, AfterViewInit {
  categoryDescription: CategoryDescription;
  companyId: number;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  categoryDescriptionForm: FormGroup;
  hasFormErrors = false;
  submissionErrorObj: any;
  hasSubmissionErrors: boolean;
  subscriptions = [];
  queryParams = new QueryParamsModel({}, 'desc', 'created', 0, 100);
  categoryAutocompleteCall = this.relationshipCategoryService.searchRelationshipCategory.bind(
    this.relationshipCategoryService,
    this.queryParams,
  );
  @ViewChild('categoryAutocomplete') categoryAutocomplete;
  filterNewCategoryFn = ((value) => {
    return value;
  }).bind(this);

  constructor(
    public dialogRef: MatDialogRef<CategoryDescriptionEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private router: Router,
    private categoryDescriptionFB: FormBuilder,
    private categoryDescriptionService: CategoryDescriptionService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private relationshipCategoryService: RelationshipCategoryService,
    public dialog: MatDialog,
    private layoutUtilsService: LayoutUtilsService,
    public stringUtils: StringUtilsService,
  ) {}

  ngOnInit() {
    this.createForm();
  }

  getTitle() {
    if (this.data.mode === 'CREATE') return 'New Description';
    return 'Update Description - ' + this.data.item.description_type;
  }

  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  createForm() {
    this.categoryDescriptionForm = this.categoryDescriptionFB.group({
      category: [
        this.data.item && this.data.item.category ? this.data.item.category : null,
        Validators.required,
      ],
      description: [
        this.data.item && this.data.item.description_type ? this.data.item.description_type : null,
        Validators.required,
      ],
    });
  }

  ngAfterViewInit() {
    if (this.data.item && this.data.item.category) {
      this.categoryAutocomplete.setValue(this.data.item.category);
    }
  }

  onSubmit() {
    this.categoryAutocomplete.updateValueAndValidity();
    this.hasFormErrors = false;
    const controls = this.categoryDescriptionForm.controls;
    if (this.categoryDescriptionForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    if (this.data.mode === 'CREATE') {
      this.addCategoryDescription(this.prepareCategoryDescription());
      return;
    }
    this.updateCategoryDescription(this.prepareCategoryDescription());
  }

  prepareCategoryDescription() {
    const controls = this.categoryDescriptionForm.controls;
    const _categoryDescription = new CategoryDescription();
    _categoryDescription.id = this.data.item && this.data.item.id ? this.data.item.id : null;
    _categoryDescription.description_type = controls.description.value;
    _categoryDescription.category = controls.category.value;
    return _categoryDescription;
  }

  addCategoryDescription(item) {
    this.categoryDescriptionService.createCategoryDescription(item).subscribe(() => {
      this.layoutUtilsService.showActionNotification(
        'Description Added Successfully',
        MessageType.Update,
        3000,
        false,
        false,
      );
      this.dialogRef.close();
    });
  }

  updateCategoryDescription(item) {
    this.categoryDescriptionService.updateCategoryDescription(item).subscribe(() => {
      this.layoutUtilsService.showActionNotification(
        'Description Updated Successfully',
        MessageType.Update,
        3000,
        false,
        false,
      );
      this.dialogRef.close();
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.categoryDescriptionForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  close() {
    this.dialogRef.close();
  }

  filterCategoryFn(event: any): string {
    return event ? event.name : '';
  }

  onCategoryChange(val) {
    this.categoryDescriptionForm.get('category').setValue(val);
    this.categoryDescriptionForm.controls.category.updateValueAndValidity();
  }
}
